import { MaintenanceActions } from '../actions/maintenance.actions';
import { CustomAction } from '../actions';

export interface MaintenanceState {
  active: boolean;
  message: string;
  support: string;
  retryAfter: number;
  source: string;
  updatedAt?: string;
  lastChecked?: string;
  error?: any;
  raw?: any;
}

const initialState: MaintenanceState = {
  active: false,
  message: null,
  support: null,
  retryAfter: null,
  source: 'default',
  updatedAt: null,
  lastChecked: null,
  error: null,
  raw: null,
};

function normalizePayload(payload: any = {}): Partial<MaintenanceState> {
  const retryAfter = payload.retry_after || payload.retryAfter;
  return {
    active: !!payload.active,
    message: payload.message || null,
    support: payload.support || null,
    retryAfter: retryAfter != null ? parseInt(retryAfter, 10) || null : null,
    source: payload.source || 'default',
    updatedAt: payload.updated_at || payload.updatedAt || null,
    raw: payload,
  };
}

export function maintenanceReducer(
  state: MaintenanceState = initialState,
  action: CustomAction,
): MaintenanceState {
  switch (action.type) {
    case MaintenanceActions.SET_MAINTENANCE_STATE: {
      const normalized = normalizePayload(action.payload);
      return {
        ...state,
        ...normalized,
        lastChecked: new Date().toISOString(),
        error: null,
      };
    }
    case MaintenanceActions.MAINTENANCE_CHECK_FAILED: {
      return {
        ...state,
        lastChecked: new Date().toISOString(),
        error: action.payload,
      };
    }
    default:
      return state;
  }
}
